import React from "react";
import { Card } from "../../Shared/Card";
import { DatosAnioListTable } from "./DatosAnioListTable";
import { Separator } from "../../ui/separator";

export const DatosAnioListDashboard: React.FC = () => {
	return (
		<Card>
			<h1 className="text-xl font-bold">Listado de Datos Anuales</h1>
			<Separator />
			<DatosAnioListTable />
		</Card>
	);
};
